/* Carrusel de productos + tarjetas .pcard (Bloque 2 y rejillas)
   - Flechas de navegación y chips (por carrusel)
   - Selector de cantidad – [n] + (global, en toda la página)
   El "Añadir" es un <form action="/cart/add"> que gestiona cart-drawer.js
   (AJAX + abrir drawer), respetando el campo quantity.
*/
(function () {
  'use strict';

  /* Selector de cantidad — global (rejillas y carrusel) */
  function bindQty(scope) {
    scope.querySelectorAll('.pcard__qty').forEach(function (q) {
      if (q.dataset.bound) return;
      q.dataset.bound = '1';
      var input = q.querySelector('.pcard__qty-input');
      var minus = q.querySelector('.pcard__qty-minus');
      var plus = q.querySelector('.pcard__qty-plus');
      if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    });
  }

  /* Flechas + chips — por cada carrusel */
  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;

    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');

    function scrollStep() {
      var card = track.querySelector('.pcard');
      var gap = 16;
      return card ? (card.getBoundingClientRect().width + gap) : 280;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollStep() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollStep() * 2, behavior: 'smooth' }); });

    var chips = root.querySelectorAll('.pcarousel__chip');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-selected', 'false'); });
        chip.classList.add('is-active');
        chip.setAttribute('aria-selected', 'true');

        var filter = chip.dataset.chip;
        var cards = track.querySelectorAll('.pcard');
        var anyMatch = Array.prototype.some.call(cards, function (c) { return c.dataset.filter === filter; });
        cards.forEach(function (c) {
          var show = !anyMatch || c.dataset.filter === filter || c.dataset.filter === 'all';
          c.style.display = show ? '' : 'none';
        });
        track.scrollTo({ left: 0, behavior: 'smooth' });
      });
    });
  }

  function initAll() {
    bindQty(document);
    document.querySelectorAll('[data-pcarousel]').forEach(initCarousel);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
